import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=75e63131&"
import script from "./OfferDetails.vue?vue&type=script&lang=js&"
export * from "./OfferDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75e63131')) {
      api.createRecord('75e63131', component.options)
    } else {
      api.reload('75e63131', component.options)
    }
    module.hot.accept("./OfferDetails.vue?vue&type=template&id=75e63131&", function () {
      api.rerender('75e63131', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/OfferDetails.vue"
export default component.exports